module.exports = __webpack_public_path__ + "static/media/1230_Music_Jazz_HL.283891a6.png";